import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { NoContentComponent } from './core/components/no-content/no-content.component';
import { LoginSsoComponent } from './public/login/login-sso/login-sso.component';
import { LoginComponent } from './public/login/login.component';
import { LogoutComponent } from './public/logout/logout.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginSsoComponent
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'login-legacy',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./public/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule)
  },
  {
    path: 'update-password',
    loadChildren: () => import('./public/update-password/update-password.module').then((m) => m.UpdatePasswordModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./public/update-password/update-password.module').then((m) => m.UpdatePasswordModule)
  },
  {
    path: 'terms-of-use',
    loadChildren: () => import('./public/terms-of-use/terms-of-use.module').then((m) => m.TermsOfUseModule)
  },
  {
    path: 'private',
    loadChildren: () => import('./private/private.module').then((m) => m.PrivateModule)
  },
  {
    path: '**',
    component: NoContentComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: NoPreloading,
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
